export default __webpack_public_path__ + "e132adcfb9e25e2bf00e27532797b4f6.png";